export default "__VITE_ASSET__C17E4r_e__"